import { useEffect, useState } from "react";
import { nodeSchema, type DesignNode } from "@proof/core";
import { Button, Control } from "./components";
const identity = { scaleX: 1, scaleY: 1, offsetX: 0, offsetY: 0 };
export function ImagePlacement({
  node,
  onChange,
}: {
  node: DesignNode;
  onChange: (patch: Partial<DesignNode>) => void;
}) {
  const value = node.imagePlacement || identity;
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [node.id, JSON.stringify(value)]);
  const valid = nodeSchema.shape.imagePlacement.safeParse(draft).success;
  return (
    <details className="image-placement">
      <summary>Image placement</summary>
      <p className="inspector-note">
        Scale and offset artwork relative to its fixed frame. Clip image to
        frame controls whether artwork can extend outside. Values retain their
        full precision.
      </p>
      <div className="control-grid">
        {(["scaleX", "scaleY", "offsetX", "offsetY"] as const).map((key) => (
          <Control
            key={key}
            label={`Image ${key.startsWith("scale") ? "scale" : "offset"} ${key.endsWith("X") ? "X" : "Y"}${key.startsWith("offset") ? " (pt)" : ""}`}
          >
            <input
              type="number"
              step="any"
              min={key.startsWith("scale") ? 0.01 : -14400}
              max={key.startsWith("scale") ? 100 : 14400}
              value={draft[key]}
              onChange={(event) =>
                setDraft({ ...draft, [key]: Number(event.target.value) })
              }
            />
          </Control>
        ))}
      </div>
      {!valid && (
        <p role="alert">
          Use scales from 0.01 to 100 and finite offsets within 14,400 points.
        </p>
      )}
      <Button
        disabled={!valid}
        onClick={() => onChange({ imagePlacement: { ...draft } })}
      >
        Apply image placement
      </Button>
      <Button onClick={() => setDraft(value)}>
        Reset image placement draft
      </Button>
      {node.imagePlacement && (
        <Button onClick={() => onChange({ imagePlacement: undefined })}>
          Remove image placement
        </Button>
      )}
    </details>
  );
}
